import type { SVGProps } from "react";

export function IconPurpleBookLock(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.33325 44.3333V9C9.33325 7.89543 10.2287 7 11.3332 7H46.0666C46.398 7 46.6666 7.26863 46.6666 7.6V39"
        stroke="#2E2E2E"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M32.6667 23.3333H34.4C34.7314 23.3333 35 23.602 35 23.9333V32.0667C35 32.398 34.7314 32.6667 34.4 32.6667H21.6C21.2686 32.6667 21 32.398 21 32.0667V23.9333C21 23.602 21.2686 23.3333 21.6 23.3333H23.3333M32.6667 23.3333V18.6667C32.6667 17.1111 31.7333 14 28 14C24.2667 14 23.3333 17.1111 23.3333 18.6667V23.3333M32.6667 23.3333H23.3333"
        stroke="#2E2E2E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 39.6667H46.6667"
        stroke="#2E2E2E"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M14 49H46.6667"
        stroke="#2E2E2E"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M14 49C11.4227 49 9.33333 46.9107 9.33333 44.3334C9.33333 41.756 11.4227 39.6667 14 39.6667"
        stroke="#2E2E2E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
